<template>
    <div class="data-wrapper-core">
        <div>
            <h3>Funnel Data</h3>
            <v-divider></v-divider>
            <h4>Funnel Name:</h4>
            <p>{{ leads.funnelData.funnelName }}</p>
            <v-divider></v-divider>
        </div>
        <div v-for="(value, key) in leads.funnelData.profile" :key="key">
            <h4>{{ key }}</h4>
            <div v-if="typeof value === 'object'">
                <div v-for="(subValue, subKey) in value" :key="subKey">
                    <p><strong>{{ subKey }}:</strong> {{ subValue }}</p>
                </div>
                <v-divider></v-divider>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        leads: {
            type: Object,
            required: true
        }
    },
}
</script>

<style lang="scss" scoped></style>